import { StyleProp, ViewStyle } from "react-native";
import PillButton from "src/components/PillButton";
import useStyle from "src/hooks/useStyle";
import IconClose from "src/icons/IconClose";
import { color } from "src/styles";
import useInsideModal from "../hooks/useInsideModal";

const CloseModalButton = ({ containerStyle }: { containerStyle?: StyleProp<ViewStyle> }) => {
	const { closeSelf } = useInsideModal();
	const { theme } = useStyle();

	return (
		<PillButton
			onPress={closeSelf}
			containerStyle={containerStyle}
			color={color.TextLight[theme]}
			Icon={IconClose}
		/>
	);
};
export default CloseModalButton;
